import { Component, OnInit } from "@angular/core";
import { EndpointsService } from "../../../services/endpoints.service";
import { HttpApiService } from "../../../services/http-api.service";
import { ProfilesService } from "../../../services/profiles.service";
import { Constants } from "../../../services/constants";


@Component({
  selector: 'app-list-rfq',
  templateUrl: './list-rfq.component.html'
})
export class ListRFQComponent implements OnInit {

  RFQs: Array<any> = [];
  requestForQ = [];
  appProfiles: any = [];

  constructor(private endpoints: EndpointsService,
    private profileService: ProfilesService,
    private Api: HttpApiService) {
    this.getRFQs();
  }

  ngOnInit() {
  }

  getRFQs() {
    this.Api.get(this.endpoints.getBuyerRFQUrl() + '?isOnlyForBuyer=true', true)
      .subscribe(response => {
        this.requestForQ = response;
      }, error => {
        console.log('error' + error.status);
      });
  }


  // getRFQs() {
  //   this.Api.get(this.endpoints.getProfileUrl("domain=" + Constants.TENANT_ID()))
  //     .subscribe(response=> {
  //       console.log("all profiles2211111111111");
  //       console.log(response[2]);
  //       this.appProfiles = response;
  //       this.Api.get(this.endpoints.getRFQListUrl(), true)
  //       .subscribe(rfqs=>{
  //         rfqs.forEach(element => {
  //           if(element!=null){
  //           element.applicationProfile = response[element.applicationProfile.id-1];
  //           this.requestForQ.push(element);
  //           console.log("required app element")
  //           console.log(response[element.applicationProfile.id-1]);
  //           }
  //         });
  //         console.log(this.requestForQ);
  //       })

  //     })
  //     console.log("rfqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
  //     console.log(this.requestForQ);


  //   // this.Api.get(this.endpoints.getRFQListUrl(), true)
  //   //   .subscribe(response=> {
  //   //     this.RFQs = response;
  //   //         console.log("all profiles hereeeeeeeeeeeeeeeeeee")
  //   //         console.log(this.appProfiles);
  //   //     response.forEach(item => {
  //   //       if(item){

  //   //       let applicationProfile = this.profileService.getProfileById(item.applicationProfile.id);
  //   //       this.appProfiles.push(applicationProfile);
  //   //       item.applicationProfile = this.profileService.getProfileById(item.applicationProfile.id);
  //   //       this.requestForQ.push(item);
  //   //       }
  //   //     });

  //   //   });
  // }

}



// WEBPACK FOOTER //
// ./src/app/components/buyer/list-rfq/list-rfq.component.ts